<template>
  <div>
    <el-card class="box-card">
      <el-button type="info" @click="backCustomerManagement">返回</el-button>

      <el-table :data="dataList" border stripe class="mt15">
        <el-table-column prop="Usertime" label="使用时长"></el-table-column>
        <el-table-column prop="Createtime" label="时间"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pages">
        <el-pagination
          @current-change="handleCurrentPageChange"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="dataListnum"
          :current-page.sync="selectedPageNo">
        </el-pagination>
      </div>

    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      parentdata: null,
      scene:''
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata,scene) {
      this.parentdata = parentdata
      this.scene = scene
      this.apiGetRslEvUserTimeNum()
      this.apiGetRslEvUserTimeList()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetRslEvUserTimeList()
    },
    apiGetRslEvUserTimeList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.Id,
        scene: that.scene,
        pageno: that.selectedPageNo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRslEvUserTimeList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetRslEvUserTimeNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.Id,
        scene: that.scene,
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRslEvUserTimeNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
